<template>
    <div class="simulator">
        <!-- @start Titulo do simulador -->
        <div class="simulator-header">
            <div class="title">Condição de Pagamento</div>
        </div>
        <!-- @end Titulo do simulador -->

        <!-- @start Formulário para Selecionar a tabela de vendas e o fluxo -->
        <ui-simulator-form-sales-table/>
        <!-- @end Formulário para Selecionar a tabela de vendas e o fluxo -->


        <!-- @start SIMULADOR - Tabela/Formulário principal -->
        <ui-simulator-table/>
        <!-- @end SIMULADOR - Tabela/Formulário principal -->


        <!-- @start Registro de informções da simulação -->
        <div class="simulator-informations" v-if="informationsComputed">
            <div class="title">Informações</div>
            <div class="text" v-html="informationsComputed"></div>
        </div>
        <!-- @end Registro de informções da simulação -->


        <!-- @start Observações da simulação -->
        <div class="simulator-observations">
            <ui-card-accordion-body>
                <ui-card-accordion-item>
                    <template v-slot:title>Observações sobre esta simulação:</template>
                    <template v-slot:content>
                        <form class="form">
                            <textarea v-model="observationComputed"/>
                        </form>
                    </template>
                </ui-card-accordion-item>                
            </ui-card-accordion-body>
        </div> 
        <!-- @end Observações da simulação -->
    </div>
</template>

<script>
    import uiSimulatorFormSalesTable from '../simulator-form-sales-table'
    import uiSimulatorTable from '../simulator-table'
    import {  uiCardAccordionBody, uiCardAccordionItem } from '@/components/ui/cards'

    import { mapGetters } from 'vuex'

    export default {
        components: {
            uiSimulatorFormSalesTable,
            uiSimulatorTable,
            uiCardAccordionBody,
            uiCardAccordionItem,
        },

        data() {
            return {
                disabledSaveObservations: true,
                interval: null
            }
        },

        computed: {
            ...mapGetters('simulation', {
                observation: 'getObservation',
                salesTable: 'getSalesTable',
            }),

            /**
             * Computed property para atualizar os dados referentes as observações da simulação no
             * state
             */
            observationComputed: {
                get() {
                    return this.observation
                },
                set(value) {
                    this.$store.dispatch('simulation/setObservation', value || '')
                }
            },

            /**
             * Computed property com as informações da tabela de vendas[etapa 4]
             */
            informationsComputed() {
                return this.salesTable.observations ? this.salesTable.observations : null
            },
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>